__turbopack_context__.v({
  "auto-complete": "r8fgda_auto-complete",
  "card": "r8fgda_card",
  "clear": "r8fgda_clear",
  "closeIcon": "r8fgda_closeIcon",
  "historyTitle": "r8fgda_historyTitle",
  "list": "r8fgda_list",
  "listItem": "r8fgda_listItem",
  "searchHistory": "r8fgda_searchHistory",
  "searchText": "r8fgda_searchText",
  "searchWord": "r8fgda_searchWord",
  "wrapper": "r8fgda_wrapper",
});
